/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { useLayoutEffect } from "react";
import { create } from "zustand";

type ScreenStore = {
  width: number;
  setWidth: (width: number) => void;
};

export const useScreenStore = create<ScreenStore>((set) => ({
  width: typeof window !== "undefined" ? window.innerWidth : 0,
/**
 * setWidth function.
 *
 * @param {*} width - Parameter description
 *
 * @returns {*} Return value description
 */
  setWidth: (width) => set({ width: width }),
}));

export const ScreenStoreProvider: ComponentWithChildren = ({ children }) => {
  useLayoutEffect(() => {
    // Update the screenWidth whenever the window is resized
    const handleResize = () =>
      useScreenStore.getState().setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return <>{children}</>;
};
